import type { Store as VuexStore, Module, CommitOptions } from "vuex";
import type { ConfigState } from "./state";
import type { Mutations } from "./mutations";

// TODO: How to surpass cyclical dependency linting errors cleanly?
import { RootState } from "@/store";
import { state } from "./state";
import { mutations } from "./mutations";

export { ConfigState };

export type ConfigStore<S = ConfigState> = Omit<
  VuexStore<S>,
  "getters" | "commit" | "dispatch"
> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
    key: K,
    payload: P,
    options?: CommitOptions
  ): ReturnType<Mutations[K]>;
};
export const store: Module<ConfigState, RootState> = {
  state,
  mutations,
};
